import styled from 'styled-components';
export const Container = styled.div `
  display: flex;
  align-items: center;
`;
export const UndefinedFlag = styled.div `
  aspect-ratio: 3/2;
  background-color: var(--bg-quaternary);

  display: flex;
  align-items: center;
  justify-content: center;

  color: var(--text-primary-invert);
  font-size: var(--font-size-200);
  font-weight: var(--font-weight-semibold);
`;
export const Label = styled.div `
  margin-left: var(--space-500);

  font-size: var(--font-size-400);
  line-height: 150%;
`;
export const Flag = styled.span `
  font-size: ${({ $height }) => $height}px;
  /* NOTE: This font is provided by "country-flag-emoji-polyfill" package when unicode emoji flags are not supported */
  font-family: 'Twemoji Country Flags', 'Helvetica', 'Comic Sans', serif;
`;
